import { ReactInstance } from 'react';
import { useReactToPrint } from 'react-to-print';
import { setPrintIframeTitle } from '../../utils/htmlUtils';

// react-to-print has a hack inside which sets @page margin to 0 to hide default print header (title) and footer (url)
// to avoid this, we send default page style without margin hack
const DEFAULT_PAGE_STYLE = `
  @media print {
    body {
      /* Tell browsers to print background colors */
      -webkit-print-color-adjust: exact; /* Chrome/Safari/Edge/Opera */
      color-adjust: exact; /* Firefox */
    }
  }
`;

interface UsePrintParams {
  title: string;
  contentRef: ReactInstance | null | undefined;
  onAfterPrint: () => void;
  onBeforeGetContent?: () => void | Promise<any>;
}

const usePrint = ({ title, contentRef, onBeforeGetContent, onAfterPrint }: UsePrintParams): (() => void) => {
  return useReactToPrint({
    pageStyle: DEFAULT_PAGE_STYLE,
    content: () => contentRef || null,
    onBeforeGetContent: () => onBeforeGetContent?.(),
    onBeforePrint: () => {
      if (title) {
        setPrintIframeTitle(title);
      }
    },
    onAfterPrint: () => {
      onAfterPrint();
    },
  });
};

export default usePrint;
